export const listingConfigDrawer = {
  close: `Cerrar`,
  componentUnavailable: `Componente no disponible.`,
};
